import { Outlet } from 'react-router-dom';

export const WelcomeLayout = () => {
  return (
    <div className="max-w-screen h-screen">
      <main className="p-2 sm:p-8 sm:pb-0 h-full">
        <Outlet />
      </main>
    </div>
  );
};
